import { Component, Inject, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingService } from '../../services/routing.service';
import { LossReportService } from '../../services/loss-report.service';
import { SfAnalyticsService } from '../../services/sf-analytics.service';
import { LogService } from '../../services/log.service';
import { BaseComponent } from '../../shared/base/base.component';
import { DamagePhotosHelpfulTipsComponent } from '../damage-photos-helpful-tips/damage-photos-helpful-tips.component';
import { MediaUploadService } from '../../services/media-upload.service';

@Component({
  selector: 'olr-damage-photos-upload',
  templateUrl: './damage-photos-upload.component.html',
  styleUrl: './damage-photos-upload.component.css'
})
export class DamagePhotosUploadComponent extends BaseComponent implements OnInit{

  photosAdded = 0;
  retrievedPhotos: {url: string, selected: boolean; }[] = [];
  allowedTypes=['image/jpeg', 'image/png', 'image/jpg', 'image/heic'];
  maxSize = 17; // 17MB
  constructor(
    @Inject('Window') private window: any,
    public lossReportService: LossReportService,
    public routingService: RoutingService,
    public router: Router,
    private analytics: SfAnalyticsService,
    public logService: LogService,
    private mediaUploadService: MediaUploadService,
    ) {
      super(lossReportService, router, routingService, logService);
      }

    ngOnInit(){

      const theFiles = this.mediaUploadService.getFiles();
      if(theFiles.length > 0){
        this.photosAdded = theFiles.length;
        this.createFileBlobUrls(theFiles);
      }
      this.analytics.setScreenChannel('filealoss-auto');
    }

    private createFileBlobUrls(files: File[]){
      const serviceFiles = this.mediaUploadService.getFiles();
      let updatedServiceFiles: File[] = [];
      for(const file of files){
        if(file.name.endsWith('.heic')){
          const approvedSize = file.size <= this.maxSize*1024*1024 && file.size > 0;
          if(!approvedSize){
            console.warn(`File size exceeds limit for : ${file.name}`);
            continue;
          }
          const theFile = {url: '/assets/img/image_32px.svg', selected: true, name: file.name};
          this.retrievedPhotos = [...this.retrievedPhotos, theFile];
          updatedServiceFiles.push(file);
        }
        const allowedType = this.allowedTypes.includes(file.type);
        const approvedSize = file.size <= this.maxSize*1024*1024 && file.size > 0;

      if(!allowedType){
          console.warn(`File type not allowed for : ${file.name}. it was Type: ${JSON.stringify(file)}`);
          continue;
        }
        if(!approvedSize){
          console.warn(`File size exceeds limit for : ${file.name}`);
          continue;
        }

        const url = URL.createObjectURL(file);
        const theFile = {url: url, selected: true, name: file.name};
        this.retrievedPhotos = [...this.retrievedPhotos, theFile];
        updatedServiceFiles.push(file)
        this.photosAdded++;

      }
      this.mediaUploadService.setFiles(updatedServiceFiles);
    }

    handleFilesUploaded(files: File[]): void {
      if (files.length <= 15) {
        this.createFileBlobUrls(files); // Process the files and update retrievedPhotos
        this.photosAdded = this.retrievedPhotos.length; // Update photosAdded to trigger rendering of damage-photos-add

      } else {
        this.window.alert('You can only upload a maximum of 15 photos.'); // Alert the user if more than 15 files are selected
        this.window['dataLayer'].isfilesSelected =this.mediaUploadService.getFiles().length > 15;
      }
    }
    handlePhotosAdded(photosAdd: number): void {
      this.photosAdded = photosAdd; // Update the count of added photos
      if(photosAdd === 0){
        this.retrievedPhotos = [];
      }
    }
}

